import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Fiz a escolha certa ao escolher o Fitclub e ao escolher o plano e programa certo, já alcancei meu corpo ideal!",
    name: 'MATHEW HENDRICKSON',
    status : 'CLIENTE'
  },
  {
    image: image2,
    review: 'Estou satisfeito com os resultados que tenho alcançado, os treinadores me ajudaram em escolher o melhor projeto para mim.',
    name: 'JOHN KEVIN',
    status: 'CLIENTE'
  },
  {
    image : image3,
    review:' A anos estou frequentando o FitClub, a equipe é fantastica e os professores acompanham nossa evolução',
    name: 'FRANKLIN',
    status: "CLIENTE"
  },
  {
    image : image3,
    review:' Estamos aqui para orientar e ajudar os membros em seu progresso na busca pelos resultados.',
    name: 'THOMAS ',
    status: "PROFESSOR"
  }
];
